import React, { useEffect } from 'react'
import SavedCards from './CardTile';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { deleteCreditCard, fetchCreditCard } from '../../features/auth/userSlice';
import { useNavigate } from 'react-router-dom';

const PaymentCards = () => {
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const { creditCards, user } = useSelector((state: RootState) => state.user);
  useEffect(() => {
    if (user?.id) {
      dispatch(fetchCreditCard(user.id))
    }

  }, [dispatch, user?.id])
  const handleDelete = (id: number) => {
    user?.id && dispatch(deleteCreditCard({ cardId: id, userId: user?.id })).unwrap()
      .then(() => {
        dispatch(fetchCreditCard(user.id));
      })

  }
  return (
    <div>
      <div className="">
        <SavedCards
          cards={creditCards}
          onDelete={(id) =>handleDelete(id) }
          onAddNew={() => navigate("/me/payment-cards/add-card")}
        />
      </div>
    </div>
  )
}

export default PaymentCards